module.exports = __webpack_public_path__ + "img/SAMT_black.d31e2bba.svg";